import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { stage } from '@/config';

export const initDatadog = () => {
  // eslint-disable-next-line no-console
  console.log('🚀 ~ initDatadog ~ stage:', stage);
  if (!['dev', 'staging', 'prod'].includes(stage)) {
    return;
  }

  datadogRum.init({
    applicationId: '64432d50-f468-48de-9801-1706f7374b99',
    clientToken: 'pub18a9f15192ed9b0d4ac290fe0d735854',
    site: 'us3.datadoghq.com',
    service: '',
    env: stage,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'allow',
    plugins: [reactPlugin({ router: true })],
  });
};
